import { ValidationResult } from './validation-result';

export interface SecurityGroup {
  id: number;
  name: string;
  activeStatus: string;
}

export class SecurityGroup {
  id: number;
  name: string;
  activeStatus: string;

  constructor() {
    this.id = 0;
    this.name = '';
  }

  validateRecord(): ValidationResult {
    const vr = new ValidationResult();

    if (!this.name || this.name.trim().length === 0) {
      vr.focus_field = 'name';
      vr.error = 'Error: Security group name is required.';
    }

    return vr;
  }
}
